/** @format */

import { Component, Inject, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { EmpUserService } from "../../../services/emp-user.service";
import { NsWISConfigurations } from "../../../models/configurations.model";
import { ApiService } from "../../../services/api.service";
import { parseZone } from "moment-timezone";
import { BookingDataService } from "../../../services/booking-data.service";
import { switchMap } from "rxjs/operators";
import { ToastService } from "mis-crystal-design-system/toast";
import { ModalService } from "mis-design-system/mis-modal";
import { IpConsentComponent } from "../ip-consent/ip-consent.component";
import { ModalRef } from "mis-design-system/mis-modal";
import { MODAL_DATA_VAR } from "mis-design-system/mis-modal";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { CookieService } from "../../../services/cookie.service";
import { IP_CONSENT_COOKIE_NAME } from "../../../constants/cookie.constants";
import { LoaderService } from "../../../services/loader.service";
import { WidgetService } from "../../../services/widget.service";

@Component({
  selector: "mis-employee-web-exp-checkin-confirm",
  templateUrl: "./checkin-confirm.component.html",
  styleUrls: ["./checkin-confirm.component.scss"]
})
export class CheckinConfirmComponent implements OnInit {
  config: NsWISConfigurations.IFeaturesEntity;
  booking: NsEmpWebExpData.IBookingDetailDTOS;
  employeeData: NsEmpWebExpData.IEmployee;
  declarationEnabled = false;
  assets = CONSTANTS_ASSETS_EMP_WEB_EXP;

  constructor(
    private user: EmpUserService,
    public modalRef: ModalRef,
    private apiService: ApiService,
    private bookingSvc: BookingDataService,
    private toast: ToastService,
    private widgetSvc: WidgetService,
    private modals: ModalService,
    @Inject(MODAL_DATA_VAR) data,
    private cookieSvc: CookieService,
    private loader: LoaderService,
    private route: ActivatedRoute
  ) {
    this.config = data.config;
    this.booking = data.booking;
    this.employeeData = data.employeeData;
  }

  ngOnInit(): void {
    this.declarationEnabled = this.config.orderOfChallenges.indexOf("declaration") > -1 && this.booking?.bookingRequestType === "OFFICE";
  }

  iframeURL() {
    const origin = `${this.config.digiPassDeclarationUrl || `${this.user.environment.empExpUI}/#/exports/inapp-popup/covid-declaration`}`;
    const token = this.route.snapshot.queryParamMap.get("auth-token");
    let URL = `${origin}?buid=${this.user.employeeInfo.buid}`;
    if (token) URL = `${URL}&auth-token=${token}`;
    return this.declarationEnabled ? URL : "";
  }

  handleCheckin(): void {
    const consent = this.cookieSvc.getCookie(IP_CONSENT_COOKIE_NAME);
    if (this.config.IPBasedCheckinEnabled && consent !== "yes" && this.booking?.bookingRequestType === "OFFICE") {
      this.modalRef.close();
      const ref = this.modals.show(IpConsentComponent, null);
      ref.afterClosed.subscribe(res => {
        if (res) {
          this.saveCheckin();
        }
      });
      return;
    }
    this.saveCheckin();
  }

  private saveCheckin(): void {
    this.loader.show();
    const type = this.booking?.bookingRequestType;
    const now = parseZone().tz(this.booking.timezone).valueOf();
    switch (type) {
      case "WFH":
        this.apiService
          .wfhUpdate(this.booking.bookingRequestId, {
            clockInTime: now,
            timestamp: now,
            type: "CLOCK_IN"
          })
          .subscribe(
            res => {
              this.loader.hide();
              this.modalRef.close();
              this.widgetSvc.refreshWidgets("HERO");
              this.widgetSvc.setWidgetAction("CHECK-IN");
              this.toast.displayMsg("Checked in successfully.");
            },
            () => {
              this.loader.hide();
              this.modalRef.close();
              this.toast.displayMsg("Something went wrong. Please try again after sometime.");
            }
          );
        break;
      case "OFFICE":
        this.bookingSvc.offices
          .pipe(
            switchMap(offices => {
              const ofc = offices.find(o => o.guid === this.booking.officeId);
              return this.apiService.wfoUpdate({
                action: "SIGNED_IN",
                bookingId: this.booking.bookingId,
                buId: this.user.employeeInfo.buid,
                empGuid: this.employeeData.empGuid,
                empId: this.employeeData.empId,
                isEntryAllowed: true,
                isScanSuccess: true,
                officeName: ofc?.address,
                requestId: this.booking.bookingRequestId,
                scanTime: String(now),
                scanType: "EMPLOYEE_WEB"
              });
            })
          )
          .subscribe(
            res => {
              this.modalRef.close();
              this.loader.hide();
              if (res?.errorCode === 500 || !res) {
                this.toast.displayMsg(res?.message || "Something went wrong. Please try again after sometime.");
                return;
              }
              this.widgetSvc.refreshWidgets("HERO");
              this.widgetSvc.setWidgetAction("CHECK-IN");
              this.toast.displayMsg("Checked in successfully.");
            },
            () => {
              this.loader.hide();
              this.modalRef.close();
              this.toast.displayMsg("Something went wrong. Please try again after sometime.");
            }
          );
        break;
      default:
        break;
    }
  }
}
